import ForgotPasswordForm from "./forgot-password-form";


export default ForgotPasswordForm;